module.exports = __webpack_public_path__ + "static/media/paw.ad5923d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollDownTrigger/paw.svg
// module id = 327
// module chunks = 0